import {
  SCAN_AND_UPLOAD_PETITIONS_REQUEST,
  SCAN_AND_UPLOAD_PETITIONS_SUCCESS,
  SCAN_AND_UPLOAD_PETITIONS_FAILED,
  RESET_BATCH_SCAN_AND_UPLOAD,
} from './actionTypes';

const initialState = {
  loading: false,
  success: false,
};

const batchScanAndUploadReducer = (state = initialState, { type }) => {
  switch (type) {
    case SCAN_AND_UPLOAD_PETITIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SCAN_AND_UPLOAD_PETITIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case SCAN_AND_UPLOAD_PETITIONS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case RESET_BATCH_SCAN_AND_UPLOAD:
      return initialState;
    default:
      return state;
  }
};

export default batchScanAndUploadReducer;
